import React from 'react'
import PropTypes from 'prop-types'

import { Form, Icon, Popup } from 'semantic-ui-react'

import Container from './GroupPermissionsSectionContainer'
import GroupPermissionsAccordion from './GroupPermissionsAccordion'
import { getCounts } from './utils'

import Button from 'Components/StandardButton'

const GroupPermissionsSection = props => {
  const { handlePermissionSelection, handlePermissionsSubmit, selectedPermissions } = props
  const counts = getCounts(selectedPermissions)
  return (
    <div>
      <Form>
        <GroupPermissionsAccordion counts={counts} handleSelection={handlePermissionSelection} selectedPermissions={selectedPermissions} />

        <br />

        <Button content="Update Permissions" icon="check" onClick={handlePermissionsSubmit} fluid />
      </Form>

      <br />

      <span>
        <Popup content="Selected Permissions" size="mini" trigger={<Icon name="lock" />} />
        {counts.total.selected}/{counts.total.total}
      </span>
    </div>
  )
}

GroupPermissionsSection.propTypes = {
  group: PropTypes.object.isRequired,
  handlePermissionSelection: PropTypes.func.isRequired,
  handlePermissionsSubmit: PropTypes.func.isRequired,
  selectedPermissions: PropTypes.array.isRequired,
}

export default Container(GroupPermissionsSection)
